module.exports = __webpack_public_path__ + "img/im_scrollfeature_10@2x.072bd53f.jpg";